"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
// Returns the index of the current focused element within the collection
// Returns -1 if the focused element is not in the collection
function findFocusedIndex(elements) {
    var focusedElem = document.activeElement;
    var focusIndex = -1;
    for (var i = 0; i < elements.length; i += 1) {
        if (focusedElem === elements[i]) {
            focusIndex = i;
            break;
        }
    }
    return focusIndex;
}
var TabBar = function (_a) {
    var children = _a.children, className = _a.className, labelId = _a.labelId;
    var containerRef = (0, react_1.useRef)();
    var handleKeyDown = function (e) {
        e.stopPropagation();
        if (e.key === ' ') {
            e.preventDefault();
        }
        // Shift focus to other tabs with wrapping at the ends
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var tabs = containerRef.current.children;
            var currentIndex = findFocusedIndex(tabs);
            if (currentIndex === -1) {
                return;
            }
            var targetIndex = currentIndex;
            if (e.key === 'ArrowLeft') {
                targetIndex = (targetIndex + tabs.length - 1) % tabs.length;
            }
            else if (e.key === 'ArrowRight') {
                targetIndex = (targetIndex + tabs.length + 1) % tabs.length;
            }
            tabs[targetIndex].focus();
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, __assign({ ref: containerRef, className: className, role: "tablist", "aria-labelledby": labelId, onKeyDown: handleKeyDown }, { children: children })));
};
exports.default = TabBar;
var templateObject_1;
